const styles = {
  cardOuterBorder: {
    position: 'relative',
    borderRadius: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 'clamp(0.2rem, 0.4vw, 0.6rem)',
    zIndex: 1,
    transition: 'transform 0.3s ease-in-out',
  },

  cardOuterBorderHover: {
    transform: 'scale(1.02)',
  },

  topImageWrapper: {
    position: 'absolute',
    top: 'clamp(-3rem, -5vw, -5rem)',
    left: '50%',
    zIndex: 6,
    pointerEvents: 'none',
  },

  topImage: {
    height: 'auto',
  },
  

  card: {
    position: 'relative',
    width: 'clamp(20rem, 45vw, 60rem)',
    height: 'clamp(20rem, 32vw, 45rem)',
    border: '1px solid rgba(200, 200, 200, 0.4)',
    borderRadius: '30px',
    overflow: 'hidden',
    zIndex: 2,
  },

  cardImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 2,
  },

  cardBlur: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(80px)',
    zIndex: 3,
  },

  iconWrapper: {
    position: 'absolute',
    borderRadius: '26px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'translate(-220%, -145%)',
    boxShadow: '0 4px 4px rgba(0, 0, 0, 0.12)',
    zIndex: 5,
  },

  icon: {
    width: 'clamp(5rem, 9vw, 12rem)',
    height: 'clamp(5rem, 9vw, 12rem)',
  },

  projectTitle: {
    position: 'absolute',
    top: 'clamp(0.6rem, 1.5vw, 2rem)',
    width: '100%',
    textAlign: 'center',
    color: '#fff',
    fontSize: 'clamp(1rem, 1.8vw, 2rem)',
    fontWeight: 200,
    zIndex: 5,
  },

  projectImageWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '92%',
    height: 'auto',
    zIndex: 4,
    textDecoration: 'none',
    display: 'block',
    borderRadius: '26px',
    pointerEvents: 'auto',
  },

  projectImage: {
    width: '100%',
    height: 'auto',
    borderRadius: '26px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  },
};

export default styles;
